// extracted by mini-css-extract-plugin
export var active = "_2d-d";
export var blink = "_2d-e";
export var container = "_2d-5";
export var controls = "_2d-0";
export var controlsRight = "_2d-1";
export var fakeCursor = "_2d-c";
export var hidden = "_2d-b";
export var quillContainerSmall = "_2d-7";
export var quillEditor = "_2d-6";
export var quillEditorSmall = "_2d-8";
export var quillFormatButtons = "_2d-a";
export var quillToolbar = "_2d-9";
export var removePadding = "_2d-2";
export var state = "_2d-3";
export var stateTitle = "_2d-4";